export default {

  todaysEodReviewPreview(context, data) {
    context.commit('todaysEodReviewPreview', data);
  },
  todaysJournal(context, data) {
    context.commit('todaysJournal', data);
  },
  
};
